import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../components/Loader';
import {
  getCategoryBySlug,
  getCachedProductsByCategoryId
} from '../Api/products';
import ProductCard from '../components/ProductCard';
import { Pagination, Stack } from '@mui/material';
import '../assets/css/categoryitem.css';

function CategoryItem({ isAuthenticated, onAddToCart }) {
  const navigate = useNavigate();
  const { category } = useParams();

  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const perPage = 12; // better UX than 50

  // Redirect admin
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user_data")) || {};
    if (userData.isSuperAdmin) {
      navigate('/dashboard');
    }
  }, [navigate]);

  // Reset page when slug changes
  useEffect(() => {
    setCurrentPage(1);
  }, [category]);

  const formattedCategoryName = category
    ? category
        .split('-')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ')
    : 'Unknown Category';

 useEffect(() => {
  const loadCategoryProducts = async () => {
    setLoading(true);

    try {
      const categoryData = await getCategoryBySlug(category);

      if (!categoryData?.id) {
        setProducts([]);
        setTotalPages(1);
        return;
      }

      const { data, totalPages } =
        await getCachedProductsByCategoryId(
          categoryData.id,
          currentPage,
          perPage
        );

      setProducts(data);
      setTotalPages(totalPages);

    } catch (err) {
      console.error("Category load failed:", err);
      setProducts([]);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  loadCategoryProducts();
}, [category, currentPage]);


  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="content-wrapper">
          <section className="particular-category">
            <h3 className="category-title">
              {formattedCategoryName.toUpperCase()}
            </h3>

            <section className="char-products-section">
              <div className="small-container d-grid">
                {products.length > 0 ? (
                  products.map(item => (
                    <ProductCard
                      key={item.id}
                      product={item}
                      isAuthenticated={isAuthenticated}
                      onAddToCart={onAddToCart}
                    />
                  ))
                ) : (
                  <p className="no-products">No products found</p>
                )}
              </div>

              {totalPages > 1 && (
                <Stack
                  spacing={2}
                  sx={{
                    mt: 4,
                    alignItems: 'center',
                  }}
                >
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={(e, val) => setCurrentPage(val)}
                    color="primary"
                  />
                </Stack>
              )}
            </section>
          </section>
        </div>
      )}
    </>
  );
}

export default CategoryItem;
